var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:!_vm.text ? 'text--disabled' : ''},[(_vm.text)?[_vm._v(_vm._s(_vm.text))]:[_vm._v("N/A")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }